import { render, staticRenderFns } from "./logistics-import.vue?vue&type=template&id=31089176&scoped=true&"
import script from "./logistics-import.vue?vue&type=script&lang=js&"
export * from "./logistics-import.vue?vue&type=script&lang=js&"
import style0 from "./logistics-import.vue?vue&type=style&index=0&id=31089176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31089176",
  null
  
)

export default component.exports